import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardActionArea, CardMedia } from '@material-ui/core';
import Grid from "@material-ui/core/Grid";
import SaveIcon from "@material-ui/icons/Save";
import { Delete, CloseOutlined } from "@material-ui/icons/";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";


const EditProduct = (props) => {
  const classes = useStyles();

  const [response, fetchData] = UseFetchData();
  const [deleteresponse, DeleteOpportunitydtlsData] = UseFetchData();
  const [Productresponse, FetchProduct] = UseFetchData();
  const [ModelCode, setModelCode] = useState("");
  const [Seq, setSeq] = useState("");
  const [Description, setDescription] = useState('');
  const [Specification, setSpecification] = useState('');
  const [NetWeight, setNetWeight] = useState('');
  const [StateName, setStateName] = useState();
  const [Currency, setCurrency] = useState();
  // const [CurrencyID,setCurrencyID] = useState();
  const [Rate, setRate] = useState(0);
  const [RateINR, setRateINR] = useState(0);
  const [Quantity, setQuantity] = useState(0);
  const [ImagePath, setImagePath] = useState('');
  const [ConversionResopnse, fetchConversion] = UseFetchData();
  const [Amount, setAmount] = useState(Rate * Quantity);
  const [DiscountPer, setDiscountPer] = useState();
  const [DiscountAmt, setDiscountAmt] = useState();
  const [Total, setTotal] = useState();
  const [GstAmount, setGstAmount] = useState();
  const [SGstAmount, setSGstAmount] = useState();
  const [IGstAmount, setIGstAmount] = useState();
  const [GstPer, setGstPer] = useState();
  const [CgstPer, setCgstPer] = useState();
  const [SgstPer, setSgstPer] = useState();
  const [IgstPer, setIgstPer] = useState();
  const [DisableIgstPer, setDisableIgstPer] = useState(false);
  // const [DisableIgstAmt, setDisableIgstAmt] = useState(false);
  const [DisableCgstPer, setDisableCgstPer] = useState(false);
  // const [DisableCgstAmt, setDisableCgstAmt] = useState(false);
  const [DisableSgstPer, setDisableSgstPer] = useState(false);
  // const [DisableSgstAmt, setDisableSgstAmt] = useState(false);
  const { value, onChange, ...rest } = props;
  const [cursor, setCursor] = useState(null);
  const ref = useRef(null);


  const validationSchema = Yup.object({
    ModelCode: Yup.string().required("Required!"),
    Quantity: Yup.string().required("Required!"),
    Rate: Yup.string().required("Required!"),
  });

  const OnDelete = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("OpportunityDtlsID", props.OpportunitydtldID);
    DeleteOpportunitydtlsData("Opportunity/DeleteOpportunityDtls", bodyFormData);
  };


  // const CalculateDiscountPer = (e) => {
  //  // debugger;
  //   const Rates = (Number(Rate) + Number(GstAmount) + Number(SGstAmount) + Number(IGstAmount)).toFixed(2);
  //   setDiscountPer(e.target.value);
  //   const Dis = (e.target.value) / 100;
  //   const DisAmt = Dis * Rate;
  //   const FinalRate = (Number(Rates) - Number(DisAmt)).toFixed(2);
  //   const FinalAmount = FinalRate * Quantity;
  //   setDiscountAmt(DisAmt.toFixed(2));
  //   console.log("total4:",Total);
  // }


  // const CalculateDiscountAmt = (e) => {
  //   const Rates = (Number(Rate) + Number(GstAmount ) + Number(SGstAmount) + Number(IGstAmount)).toFixed(2);
  //   setDiscountAmt(e.target.value);
  //   const FinalRate = Rates - (e.target.value);
  //   const DisAmt = (e.target.value) / Rate;
  //   const Dist = DisAmt * 100;
  //   const FinalAmount = FinalRate * Quantity;
  //   setDiscountPer(Dist.toFixed(2));
  //   console.log("total3:",Total);
  // }



  useEffect(() => {
    if (deleteresponse.Response === true) {
      props.setOpen(false);
      props.getByIDData()
    } else if (deleteresponse.Response === false) {
      alert("Failed.");
    }
  }, [deleteresponse]);

  useEffect(() => {
    const input = ref.current;
    if (input) input.setSelectionRange(cursor, cursor);
  }, [ref, cursor, value]);

  const handleChange = (e) => {
    // setCursor(e.target.selectionStart);
    onChange && onChange(e);
  };


  const onSubmit = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("OpportunityDtlsID", props.OpportunitydtldID);
    bodyFormData.append("OpportunityID", props.OpportunityID);
    bodyFormData.append("Seq", Seq);
    bodyFormData.append("ProductID", "");
    bodyFormData.append("Description", Description);
    bodyFormData.append("Specification", Specification);
    bodyFormData.append("Quantity", Quantity);
    bodyFormData.append("Rate", Rate);
    bodyFormData.append("RateINR", RateINR);
    bodyFormData.append("DiscountPer", DiscountPer);
    bodyFormData.append("DiscountAmt", DiscountAmt);
    // bodyFormData.append("CurrencyID", CurrencyID);
    bodyFormData.append("ConvFactor", "0");
    bodyFormData.append("CurrencyRate", "0");
    bodyFormData.append("Amount", Amount);
    bodyFormData.append("CgstPer", CgstPer);
    bodyFormData.append("CgstAmt", GstAmount);
    bodyFormData.append("SgstPer", SgstPer);
    bodyFormData.append("SgstAmt", SGstAmount);
    bodyFormData.append("IgstPer", IgstPer);
    bodyFormData.append("IgstAmt", IGstAmount);
    bodyFormData.append("NetWeight", NetWeight);
    bodyFormData.append("TotalAmount", Total);
    fetchData("Opportunity/AddProduct", bodyFormData);
  };

  useEffect(() => {
    if (response.Response === true) {
      props.setOpen(false);
      props.getByIDData()
    } else if (response.Response === false) {
      if (response.Message.includes("Already") === true) {
        alert(response.Message);
      } else {
        alert("Failed.");
      }
    }
  }, [response]);


  useEffect(() => {
    //// debugger;
    if (ConversionResopnse !== undefined) {
      if (ConversionResopnse["ConversionData"] !== undefined) {
        // debugger;
        setCurrency(ConversionResopnse["ConversionData"][0]["Currency"]);
      }
    }
  }, [ConversionResopnse]);

  useEffect(() => {
    GetConversionDate();
  });

  const PopulateData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("OpportunitydtlsID", props.OpportunitydtldID);
    FetchProduct("Opportunity/OpportunityDtlsByID", bodyFormData);
  };

  useEffect(() => {
    PopulateData();
  }, []);


  const GetConversionDate = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("SalesOrderID", props.SOID);
    fetchConversion("SalesOrder/ConversionData", bodyFormData);
  }

  useEffect(() => {
    if (Productresponse.length > 0) {
      setModelCode(Productresponse[0].ModelCode);
      setSeq(Productresponse[0].Seq);
      setDescription(Productresponse[0].Description);
      setSpecification(Productresponse[0].Specification);
      setQuantity(Productresponse[0].Quantity);
      setRate(Productresponse[0].Rate);
      setRateINR(Productresponse[0].RateINR);
      // setAmount(Productresponse[0].Amount);
      // setCurrencyID(Productresponse[0].CurrencyID);
      console.log('CurrencyID:', Productresponse[0].CurrencyID)
      setCurrency(Productresponse[0].Currency);
      setImagePath(Productresponse[0].FilePath);
      setDiscountPer(Productresponse[0].DiscountPer);
      setDiscountAmt(Productresponse[0].DiscountAmt);
      setTotal(Productresponse[0].TotalAmount);
      setGstAmount(Productresponse[0].GstAmount);
      setSGstAmount(Productresponse[0].SGstAmount);
      setIGstAmount(Productresponse[0].IGstAmount);
      // debugger;
      setCgstPer(Productresponse[0].CgstPer);
      setSgstPer(Productresponse[0].SgstPer);
      setIgstPer(Productresponse[0].IgstPer);
      setNetWeight(Productresponse[0].NetWeight);
      setStateName(Productresponse[0].StateName);
      setCurrency(Productresponse[0].Currency);

      // if (Productresponse[0].Currency != "INR")
      // {
      //   setDisableIgstPer(true);
      //   setIgstPer(0);
      //   setIGstAmount(0); 
      //   setDisableCgstPer(true);
      //   setCgstPer(0);
      //   setGstAmount(0);
      //   setDisableSgstPer(true);
      //   setSGstAmount(0);
      //   setSgstPer(0);
      // }
      if (Productresponse[0].StateName === "Maharashtra") {
        setDisableIgstPer(true);
        setIgstPer(0);
        setIGstAmount(0);
      }
      else {
        setDisableCgstPer(true);
        setCgstPer(0);
        setGstAmount(0);
        setDisableSgstPer(true);
        setSGstAmount(0);
        setSgstPer(0);
      }
    }
  }, [Productresponse]);

  useEffect(() => {

    setAmount(Quantity * Rate);
    // debugger;
    // setTotal(((Quantity * Rate) + ((IgstPer + CgstPer + SgstPer) / 100) * Rate * Quantity - DiscountAmt * Quantity).toFixed(2));
    if (Currency != "INR") {
      setTotal((Quantity * Rate).toFixed(2));
    } else {
      setTotal((Quantity * RateINR).toFixed(2));
    }

  }, [Rate, RateINR, Quantity, Currency]);

  return (
    <div>
      <Formik
        initialValues={{
          ModelCode: ModelCode,
          Seq: Seq,
          Description: Description,
          Specification: Specification,
          Rate: Rate,
          RateINR: RateINR,
          Quantity: Quantity,
          Amount: Amount,
          // CurrencyID:CurrencyID,
          Currency: Currency,
          DiscountPer: DiscountPer,
          DiscountAmt: DiscountAmt,
          Total: Total,
          GstPer: GstPer,
          CgstPer: CgstPer,
          SgstPer: SgstPer,
          IgstPer: IgstPer,
          NetWeight: NetWeight,
          GstAmount: GstAmount,
          SGstAmount: SGstAmount,
          IGstAmount: IGstAmount,
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              <Grid spacing={1} container direction="row">
                <Grid spacing={1} item xs={8} container>
                  <Grid item xs={6}>
                    <BiztranControlsFormik
                      control="input"
                      type="text"
                      label="Model Code"
                      name="ModelCode"
                      disabled
                      onChange={(e) => setModelCode(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <BiztranControlsFormik
                      control="input"
                      type="text"
                      label="Seq"
                      name="Seq"
                      onChange={(e) => setSeq(e.target.value)}
                    />
                  </Grid>
                  <Grid spacing={1} container direction="row">
                    <Grid item xs={12}>
                      <BiztranControlsFormik
                        autoFocus="autofocus"
                        control="textarea"
                        type="text"
                        label="Description"
                        name="Description"
                        ref={ref}
                        value={Description}
                        onChange={(e) => {
                          setDescription(e.target.value)
                          handleChange()
                        }
                        }
                      />
                    </Grid></Grid>
                  {/* <Grid spacing={1} container direction="row">
                    <Grid item xs={12}>
                      <BiztranControlsFormik
                        autoFocus="autofocus"
                        control="textarea"
                        type="text"
                        label="Specification"
                        name="Specification"
                        ref={ref}
                        value={Specification}
                        onChange={(e) => {
                          setSpecification(e.target.value)
                          handleChange()
                        }}
                      />
                    </Grid>
                  </Grid> */}
                  <Grid container direction="row" spacing={2} marginTop={5}>
                    <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="Quantity"
                        name="Quantity"
                        onChange={(e) => setQuantity(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="RateINR"
                        name="RateINR"
                        onChange={(e) => setRateINR(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="RateUSD"
                        name="Rate"
                        onChange={(e) => setRate(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                  <Grid container direction="row" spacing={2} marginTop={5}>
                    <Grid item xs={6} md={1} sm={2} lg={2} xl={2} >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="Currency"
                        name="Currency"
                        disabled
                        onChange={(e) => setCurrency(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                      <BiztranControlsFormik
                        control="input"
                        type="text"
                        label="Total"
                        name="Total"
                        disabled
                        onChange={(e) => setTotal(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Card className={classes.root}>
                    <CardActionArea onClick={() => { window.open(ImagePath); }}>
                      <CardMedia
                        component="img"
                        //alt={FileName}
                        height="230"
                        image={ImagePath}
                        title="Product"
                      />
                    </CardActionArea>
                  </Card>
                </Grid>
              </Grid>

              <Grid spacing={2} container direction="row">
                <Grid item xs={12}>
                  <div style={{ width: '100%' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                      <BiztranControls.Button
                        text="Update"
                        type="submit"
                        startIcon={<SaveIcon />}
                      />
                      <BiztranControls.Button
                        text="Delete"
                        onClick={() => {
                          OnDelete();
                        }}
                        startIcon={<Delete />}
                      />
                      <BiztranControls.Button
                        text="CLOSE"
                        startIcon={<CloseOutlined />}
                        onClick={() => { props.setOpen(false); }}
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  headertext: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    paddingLeft: "30px",
    fontSize: "1.5rem",
    marginTop: "-16px",
    marginBottom: "10px",
    marginLeft: "-24px",
    marginRight: "-24px",
  },
  root: {
    height: '100%',
    width: '100%',
    paddingTop: '7%',
  },
}));

export default EditProduct;
